const SALES_ASSIST_TRACKING_EVENTS = {
  salesAssist: {
    formFieldFilled: true,
    viewed: true,
    clicked: true,
    error: true,
    action: true,
    accountInfo: {
      emailFieldFilled: true,
      error: true,
      firstNameFieldFilled: true,
      lastNameFieldFilled: true,
      nextClicked: true,
      passwordFieldFilled: true,
      phoneFieldFilled: true,
    },
    businessInfo: {
      gmbClick: true,
    },
    createTrial: {
      error: true,
      success: true,
    },
    selectedBundle: {
      plan: true,
    },
  },
};

export default SALES_ASSIST_TRACKING_EVENTS;
